const API_BASE = process.env.REACT_APP_API_URL || "https://docgen-ai-agent.onrender.com";
export default API_BASE;
